import isObject from "lodash.isobject";
import camelCase from "lodash.camelcase";
import reduce from "lodash.reduce";
import { IKeyValuePair, Nullable } from "../types";

const camelCaseKeys = (obj: object | object[]) => {
  if (!isObject(obj)) {
    return obj;
  } else if (Array.isArray(obj)) {
    return obj.map(v => camelCaseKeys(v));
  }
  return reduce(
    obj,
    (r, v, k) => {
      return {
        ...r,
        [camelCase(k)]: camelCaseKeys(v)
      };
    },
    {}
  );
};

const serializeObjectToKeyValuePairs = (object: Nullable<Object>): IKeyValuePair[] => {
  return object
    ? Object.keys(object).map(key => {
        return { key, value: object[key] };
      })
    : [];
};

const objectUtils = { camelCaseKeys, serializeObjectToKeyValuePairs };

export default objectUtils;
